import React from "react";
import { PrimaryButtonLink, PrimaryButton } from "../../../components/Buttons";
import { connect } from "react-redux";
import { exportCompanies } from "../actions";
import { Organisation } from "../../Permissions/resources";
import {
  isResourceEditable,
  isResourceReadable,
} from "../../Permissions/actions";

const mapStateToProps = (state) => ({
  permissions: state.permissions.permissionMap,
});
const mapDispatchToProps = (dispatch) => ({
  getCompaniesAsCSV: (...args) => dispatch(exportCompanies(...args)),
});

function CompanyListMenu({
  className = "",
  permissions,
  getCompaniesAsCSV,
}) {
  const onExportCompanies = (event) => {
    if (event) event.preventDefault();
    getCompaniesAsCSV();
  };
  const isReadable = isResourceReadable(
    Organisation.CompanyWizard.BasicInfo,
    permissions,
  );
  const isEditable = isResourceEditable(
    Organisation.CompanyWizard.BasicInfo,
    permissions,
  );
  return (
    <div className={`company list-menu ${className}`}>
      {isReadable && isEditable && (
        <PrimaryButtonLink
          to={`/wizard/organisation/firma/neu`}
          name="addCompanyBtn"
        >
          {`Servicepartner hinzufügen`}
        </PrimaryButtonLink>
      )}
      <PrimaryButton
        className="margin-lft"
        name="exportCompanyBtn"
        onClick={onExportCompanies}
      >
        {"CSV Exportieren"}
      </PrimaryButton>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyListMenu);
